import "./src/scss/style.scss";
import "./src/js/modules/index";

